import { PropsWithChildren } from "react";
import { LocalizationProvider as _LocalizationProvider } from "@myplant-io/utils/localization";
import { enUS, de } from "date-fns/locale";
import { useAuth } from "@myplant-io/hooks";
import { API_BASE_URL } from "../constants";

export function LocalizationProvider({ children }: PropsWithChildren<unknown>) {
  const { data } = useAuth(API_BASE_URL);
  return (
    <_LocalizationProvider
      userProfile={data?.user.profile}
      adapterLocales={{
        en: enUS,
        de,
      }}
    >
      {children}
    </_LocalizationProvider>
  );
}
